!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("node-fetch")) : "function" == typeof define && define.amd ? define(["node-fetch"], t) : "object" == typeof exports ? exports.bundle = t(require("node-fetch")) : e.bundle = t(e["node-fetch"]);
}(this, function (e) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 5);
  }([function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MAINNET = "mainnet", t.ROPSTEN = "ropsten", t.KOVAN = "kovan", t.RINKEBY = "rinkeby", t.PRICE_PRECISION = 7, t.AMOUNT_PRECISION = 5, t.TO_WEI = 1e18, function (e) {
      e.ETHFINEX = "Ethfinex", e.ETHFINEX_RAW = "EthfinexRaw", e.ERCDEX = "ERCdEX", e.ZEROEXRELAYER = "0xStandardRelayer";
    }(t.supportedExchanges || (t.supportedExchanges = {})), function (e) {
      e[e.MAINNET = 1] = "MAINNET", e[e.KOVAN = 42] = "KOVAN", e[e.ROPSTEN = 3] = "ROPSTEN", e[e.RINKEBY = 4] = "RINKEBY";
    }(t.NETWORKS || (t.NETWORKS = {})), function (e) {
      e.CLOSED = "closed", e.OPEN = "open", e.CONNECTING = "connecting", e.CLOSING = "closing";
    }(t.WS_STATUS || (t.WS_STATUS = {}));
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      function n(e) {
        o.length || (r(), !0), o[o.length] = e;
      }

      e.exports = n;
      var r,
          o = [],
          i = 0,
          s = 1024;

      function u() {
        for (; i < o.length;) {
          var e = i;

          if (i += 1, o[e].call(), i > s) {
            for (var t = 0, n = o.length - i; t < n; t++) {
              o[t] = o[t + i];
            }

            o.length -= i, i = 0;
          }
        }

        o.length = 0, i = 0, !1;
      }

      var c = void 0 !== t ? t : self,
          a = c.MutationObserver || c.WebKitMutationObserver;

      function f(e) {
        return function () {
          var t = setTimeout(r, 0),
              n = setInterval(r, 50);

          function r() {
            clearTimeout(t), clearInterval(n), e();
          }
        };
      }

      r = "function" == typeof a ? function (e) {
        var t = 1,
            n = new a(e),
            r = document.createTextNode("");
        return n.observe(r, {
          characterData: !0
        }), function () {
          t = -t, r.data = t;
        };
      }(u) : f(u), n.requestFlush = r, n.makeRequestCallFromTimer = f;
    }).call(this, n(8));
  }, function (e, t, n) {
    "use strict";

    var r = n(1);

    function o() {}

    var i = null,
        s = {};

    function u(e) {
      if ("object" != typeof this) throw new TypeError("Promises must be constructed via new");
      if ("function" != typeof e) throw new TypeError("Promise constructor's argument is not a function");
      this._h = 0, this._i = 0, this._j = null, this._k = null, e !== o && p(e, this);
    }

    function c(e, t) {
      for (; 3 === e._i;) {
        e = e._j;
      }

      if (u._l && u._l(e), 0 === e._i) return 0 === e._h ? (e._h = 1, void (e._k = t)) : 1 === e._h ? (e._h = 2, void (e._k = [e._k, t])) : void e._k.push(t);
      !function (e, t) {
        r(function () {
          var n = 1 === e._i ? t.onFulfilled : t.onRejected;

          if (null !== n) {
            var r = function (e, t) {
              try {
                return e(t);
              } catch (e) {
                return i = e, s;
              }
            }(n, e._j);

            r === s ? f(t.promise, i) : a(t.promise, r);
          } else 1 === e._i ? a(t.promise, e._j) : f(t.promise, e._j);
        });
      }(e, t);
    }

    function a(e, t) {
      if (t === e) return f(e, new TypeError("A promise cannot be resolved with itself."));

      if (t && ("object" == typeof t || "function" == typeof t)) {
        var n = function (e) {
          try {
            return e.then;
          } catch (e) {
            return i = e, s;
          }
        }(t);

        if (n === s) return f(e, i);
        if (n === e.then && t instanceof u) return e._i = 3, e._j = t, void l(e);
        if ("function" == typeof n) return void p(n.bind(t), e);
      }

      e._i = 1, e._j = t, l(e);
    }

    function f(e, t) {
      e._i = 2, e._j = t, u._m && u._m(e, t), l(e);
    }

    function l(e) {
      if (1 === e._h && (c(e, e._k), e._k = null), 2 === e._h) {
        for (var t = 0; t < e._k.length; t++) {
          c(e, e._k[t]);
        }

        e._k = null;
      }
    }

    function h(e, t, n) {
      this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n;
    }

    function p(e, t) {
      var n = !1,
          r = function (e, t, n) {
        try {
          e(t, n);
        } catch (e) {
          return i = e, s;
        }
      }(e, function (e) {
        n || (n = !0, a(t, e));
      }, function (e) {
        n || (n = !0, f(t, e));
      });

      n || r !== s || (n = !0, f(t, i));
    }

    e.exports = u, u._l = null, u._m = null, u._n = o, u.prototype.then = function (e, t) {
      if (this.constructor !== u) return function (e, t, n) {
        return new e.constructor(function (r, i) {
          var s = new u(o);
          s.then(r, i), c(e, new h(t, n, s));
        });
      }(this, e, t);
      var n = new u(o);
      return c(this, new h(e, t, n)), n;
    };
  }, function (e, t, n) {
    "use strict";

    var r,
        o,
        i,
        s = this && this.__assign || function () {
      return (s = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        u = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function s(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          e.done ? o(e.value) : new n(function (t) {
            t(e.value);
          }).then(s, u);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        c = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          s = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: u(0),
        throw: u(1),
        return: u(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function u(i) {
        return function (u) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; s;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return s.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    s.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = s.ops.pop(), s.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      s = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      s.label = i[1];
                      break;
                    }

                    if (6 === i[0] && s.label < o[1]) {
                      s.label = o[1], o = i;
                      break;
                    }

                    if (o && s.label < o[2]) {
                      s.label = o[2], s.ops.push(i);
                      break;
                    }

                    o[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }

                i = t.call(e, s);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, u]);
        };
      }
    },
        a = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var f = n(0),
        l = n(4),
        h = a(n(18)),
        p = a(n(19)),
        d = function () {
      function e(t, n, r) {
        var o = this;
        this.networkId = t, this.httpUrl = n, this.wsUrl = r, this.wsStatus = f.WS_STATUS.CLOSED, this.http = {
          getTickers: function getTickers(e) {
            var t = o.HTTP_URL + "/tickers",
                n = e.symbols.map(function (e) {
              return "t" + e;
            }).toString(),
                r = l.getQueryParameters({
              symbols: n
            });
            return l.fetchJSON(t, r);
          },
          getOrders: function getOrders(t) {
            var n = t.precision || e.OrderPrecisions.P0,
                r = o.HTTP_URL + "/book/t" + t.symbols + "/" + n;
            return l.fetchJSON(r);
          },
          getCandles: function getCandles(e) {
            var t = o.HTTP_URL + "/candles/trade:" + e.timeframe + ":t" + e.symbols + "/" + e.section,
                n = e.limit,
                r = e.start,
                i = e.sort,
                s = e.end,
                u = l.getQueryParameters({
              limit: n,
              sort: i,
              start: r,
              end: s
            });
            return l.fetchJSON(t, u);
          },
          trustless: {
            getConfig: function getConfig() {
              var e = o.TRUSTLESS_URL + "/r/get/conf";
              return l.postJSON(e);
            },
            submitOrder: function submitOrder(e, t, n, r, i, s) {
              var u = o.TRUSTLESS_URL + "/w/on",
                  c = {
                type: e,
                symbol: t,
                amount: n,
                price: r,
                meta: i,
                protocol: s
              };
              return l.postJSON(u, c);
            },
            cancelOrder: function cancelOrder(e, t, n) {
              var r = o.TRUSTLESS_URL + "/w/oc",
                  i = {
                orderId: e,
                protocol: t,
                signature: n
              };
              return l.postJSON(r, i);
            },
            getOpenOrders: function getOpenOrders(e, t, n, r) {
              var i = o.TRUSTLESS_URL + "/r/orders/" + e,
                  s = {
                protocol: t,
                nonce: n,
                signature: r
              };
              return l.postJSON(i, s);
            },
            getOrderHistory: function getOrderHistory(e, t, n) {
              var r = o.TRUSTLESS_URL + "/r/orders/hist",
                  i = {
                protocol: e,
                nonce: t,
                signature: n
              };
              return l.postJSON(r, i);
            }
          }
        }, this.ws = {
          open: function open() {
            return o.wsStatus = f.WS_STATUS.CONNECTING, o.wsInstance = new h.default(o.WS_URL, [], {
              WebSocket: "undefined" != typeof window && window.WebSocket ? window.WebSocket : p.default,
              minReconnectionDelay: 1
            }), new Promise(function (e, t) {
              var n = function n(e) {
                return t(e);
              };

              o.wsInstance.addEventListener("error", n), o.wsInstance.addEventListener("open", function () {
                return o.wsInstance.removeEventListener("error", n), o.wsStatus = f.WS_STATUS.OPEN, e(o.wsInstance);
              });
            });
          },
          close: function close() {
            return o.wsStatus = f.WS_STATUS.CLOSING, new Promise(function (e) {
              o.wsInstance.addEventListener("close", function () {
                return o.wsStatus = f.WS_STATUS.CLOSED, o.wsInstance = null, e();
              }), o.wsInstance.close(1e3, "Closed by client", {
                keepClosed: !0
              });
            });
          },
          getConnection: function getConnection() {
            return o.wsInstance || o.ws.open();
          },
          getTickers: function getTickers(e, t) {
            return u(o, void 0, void 0, function () {
              var n,
                  r,
                  o = this;
              return c(this, function (i) {
                switch (i.label) {
                  case 0:
                    return [4, this.ws.getConnection()];

                  case 1:
                    return n = i.sent(), r = e.symbols.map(function (e) {
                      var r = o.messagesListener(n, function (t) {
                        return t.pair === e;
                      }, t),
                          i = {
                        event: "subscribe",
                        channel: "ticker",
                        symbol: "t" + e
                      };
                      return n.send(JSON.stringify(i)), r;
                    }), [2, function () {
                      return r.map(function (e) {
                        return e();
                      });
                    }];
                }
              });
            });
          },
          getAggregatedOrders: function getAggregatedOrders(t, n) {
            return u(o, void 0, void 0, function () {
              var r, o, i, u, a;
              return c(this, function (c) {
                switch (c.label) {
                  case 0:
                    return r = {
                      symbols: "ETHUSD",
                      precision: e.OrderPrecisions.P2,
                      frequency: e.BookFrequency.F1,
                      len: 25,
                      configFlags: [e.ConfigurationFlags.SEQ_ALL, e.ConfigurationFlags.CHECKSUM]
                    }, t = s({}, r, t), [4, this.ws.getConnection()];

                  case 1:
                    return o = c.sent(), i = {
                      event: "subscribe",
                      channel: "book",
                      pair: "t" + t.symbols,
                      prec: "" + t.precision,
                      freq: "" + t.frequency,
                      len: t.len
                    }, u = this.messagesListener(o, function (e) {
                      return e.symbol === "t" + t.symbols;
                    }, n), a = t.configFlags.reduce(function (e, t) {
                      return e + t;
                    }), o.send(JSON.stringify({
                      event: "conf",
                      flags: a
                    })), o.send(JSON.stringify(i)), [2, u];
                }
              });
            });
          },
          getCandles: function getCandles(e, t) {
            return u(o, void 0, void 0, function () {
              var n, r, o;
              return c(this, function (i) {
                switch (i.label) {
                  case 0:
                    return [4, this.ws.getConnection()];

                  case 1:
                    return n = i.sent(), r = {
                      event: "subscribe",
                      channel: "candles",
                      key: "trade:" + e.timeframe + ":t" + e.symbols
                    }, o = this.messagesListener(n, function (t) {
                      return t.key === "trade:" + e.timeframe + ":t" + e.symbols;
                    }, t), n.send(JSON.stringify(r)), [2, o];
                }
              });
            });
          }
        }, this.messagesListener = function (e, t, n) {
          var r, o;
          return r = function r(e) {
            var r = JSON.parse(e.data);
            return "subscribed" === r.event && t(r) ? (o = r.chanId, n(null, r)) : Array.isArray(r) && r[0] === o ? n(null, r) : void 0;
          }, e.addEventListener("message", r), function () {
            if (r && o) return e.send(JSON.stringify({
              event: "unsubscribe",
              chanId: o
            })), e.removeEventListener("message", r);
          };
        }, this.options = {
          orderPrecisions: e.OrderPrecisions,
          configurationFlags: e.ConfigurationFlags,
          bookFrequency: e.BookFrequency,
          candlesTimeFrame: e.CandlesTimeFrame,
          candlesSection: e.CandlesSection,
          candlesSort: e.CandlesSort
        }, this.HTTP_URL = n || e.API_HTTP_URLS[t], this.WS_URL = r || e.API_WS_URLS[t], this.TRUSTLESS_URL = e.TRUSTLESS_URLS[t];
      }

      return e.prototype.network = function (t) {
        return void 0 === t && (t = f.NETWORKS.MAINNET), new e(t);
      }, e.SUPPORTED_NETWORKS = [f.NETWORKS.MAINNET, f.NETWORKS.ROPSTEN, f.NETWORKS.KOVAN], e.API_HTTP_URLS = ((r = {})[f.NETWORKS.MAINNET] = "https://api.ethfinex.com/v2", r[f.NETWORKS.ROPSTEN] = "https://test.ethfinex.com/v2", r[f.NETWORKS.KOVAN] = "https://test.ethfinex.com/v2", r), e.API_WS_URLS = ((o = {})[f.NETWORKS.MAINNET] = "wss://api.ethfinex.com/ws/2", o[f.NETWORKS.ROPSTEN] = "wss://test.ethfinex.com/ws/2", o[f.NETWORKS.KOVAN] = "wss://test.ethfinex.com/ws/2", o), e.TRUSTLESS_URLS = ((i = {})[f.NETWORKS.MAINNET] = "https://api.ethfinex.com/trustless/v1", i), e;
    }();

    t.EthfinexRaw = d, function (e) {
      !function (e) {
        e.P0 = "P0", e.P1 = "P1", e.P2 = "P2", e.P3 = "P3", e.P4 = "P4", e.R0 = "R0";
      }(e.OrderPrecisions || (e.OrderPrecisions = {})), function (e) {
        e[e.DEC_S = 8] = "DEC_S", e[e.TIME_S = 32] = "TIME_S", e[e.TIMESTAMP = 32768] = "TIMESTAMP", e[e.SEQ_ALL = 65536] = "SEQ_ALL", e[e.CHECKSUM = 131072] = "CHECKSUM";
      }(e.ConfigurationFlags || (e.ConfigurationFlags = {})), function (e) {
        e.F0 = "F0", e.F1 = "F1";
      }(e.BookFrequency || (e.BookFrequency = {})), function (e) {
        e.ONE_MIN = "1m", e.FIVE_MINS = "5m", e.FIFTEEN_MINS = "15m", e.THIRTY_MINS = "30m", e.ONE_HOUR = "1h", e.THREE_HRS = "3h", e.SIX_HRS = "6h", e.TWELVE_HRS = "12h", e.ONE_DAY = "1D", e.SEVEN_DAYS = "7D", e.TWO_WEEKS = "14D", e.ONE_MONTH = "1M";
      }(e.CandlesTimeFrame || (e.CandlesTimeFrame = {})), function (e) {
        e.HIST = "hist", e.LAST = "last";
      }(e.CandlesSection || (e.CandlesSection = {})), function (e) {
        e.NEW_FIRST = "-1", e.OLD_FIRST = "1";
      }(e.CandlesSort || (e.CandlesSort = {}));
    }(d = t.EthfinexRaw || (t.EthfinexRaw = {})), t.EthfinexRaw = d, t.default = d;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(n(17));
    t.getQueryParameters = function (e) {
      return void 0 === e && (e = {}), Object.entries(e).map(function (e) {
        return e.join("=");
      }).reduce(function (e, t) {
        return [e, t].join("&");
      }, "");
    }, t.fetchJSON = function (e, t) {
      return ("undefined" != typeof window && window.fetch ? window.fetch : o.default)([e, t || ""].join("?")).then(function (e) {
        return e.json().catch(function (e) {
          console.log("Looks like there was a problem: \n", e);
        });
      });
    }, t.postJSON = function (e, t) {
      return ("undefined" != typeof window && window.fetch ? window.fetch : o.default)(e, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(t)
      }).then(function (e) {
        return e.json();
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n(6), n(11);
    var o = r(n(12)),
        i = n(0);
    t.supportedExchanges = i.supportedExchanges, t.NETWORKS = i.NETWORKS, t.default = o.default;
  }, function (e, t, n) {
    n(7);
    "undefined" == typeof Promise && (Promise = n(2), n(9)), n(10);
  }, function (e, t, n) {
    "use strict";

    var r = n(1),
        o = [],
        i = [],
        s = r.makeRequestCallFromTimer(function () {
      if (i.length) throw i.shift();
    });

    function u(e) {
      var t;
      (t = o.length ? o.pop() : new c()).task = e, r(t);
    }

    function c() {
      this.task = null;
    }

    e.exports = u, c.prototype.call = function () {
      try {
        this.task.call();
      } catch (e) {
        u.onerror ? u.onerror(e) : (i.push(e), s());
      } finally {
        this.task = null, o[o.length] = this;
      }
    };
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    var r = n(2);
    e.exports = r;
    var o = f(!0),
        i = f(!1),
        s = f(null),
        u = f(void 0),
        c = f(0),
        a = f("");

    function f(e) {
      var t = new r(r._n);
      return t._i = 1, t._j = e, t;
    }

    r.resolve = function (e) {
      if (e instanceof r) return e;
      if (null === e) return s;
      if (void 0 === e) return u;
      if (!0 === e) return o;
      if (!1 === e) return i;
      if (0 === e) return c;
      if ("" === e) return a;
      if ("object" == typeof e || "function" == typeof e) try {
        var t = e.then;
        if ("function" == typeof t) return new r(t.bind(e));
      } catch (e) {
        return new r(function (t, n) {
          n(e);
        });
      }
      return f(e);
    }, r.all = function (e) {
      var t = Array.prototype.slice.call(e);
      return new r(function (e, n) {
        if (0 === t.length) return e([]);
        var o = t.length;

        function i(s, u) {
          if (u && ("object" == typeof u || "function" == typeof u)) {
            if (u instanceof r && u.then === r.prototype.then) {
              for (; 3 === u._i;) {
                u = u._j;
              }

              return 1 === u._i ? i(s, u._j) : (2 === u._i && n(u._j), void u.then(function (e) {
                i(s, e);
              }, n));
            }

            var c = u.then;
            if ("function" == typeof c) return void new r(c.bind(u)).then(function (e) {
              i(s, e);
            }, n);
          }

          t[s] = u, 0 == --o && e(t);
        }

        for (var s = 0; s < t.length; s++) {
          i(s, t[s]);
        }
      });
    }, r.reject = function (e) {
      return new r(function (t, n) {
        n(e);
      });
    }, r.race = function (e) {
      return new r(function (t, n) {
        e.forEach(function (e) {
          r.resolve(e).then(t, n);
        });
      });
    }, r.prototype.catch = function (e) {
      return this.then(null, e);
    };
  }, function (e, t) {
    "function" != typeof Promise.prototype.done && (Promise.prototype.done = function (e, t) {
      (arguments.length ? this.then.apply(this, arguments) : this).then(null, function (e) {
        setTimeout(function () {
          throw e;
        }, 0);
      });
    });
  }, function (e, t) {
    !function (e) {
      "use strict";

      if (!e.fetch) {
        var t = {
          searchParams: "URLSearchParams" in e,
          iterable: "Symbol" in e && "iterator" in Symbol,
          blob: "FileReader" in e && "Blob" in e && function () {
            try {
              return new Blob(), !0;
            } catch (e) {
              return !1;
            }
          }(),
          formData: "FormData" in e,
          arrayBuffer: "ArrayBuffer" in e
        };
        if (t.arrayBuffer) var n = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
            r = function r(e) {
          return e && DataView.prototype.isPrototypeOf(e);
        },
            o = ArrayBuffer.isView || function (e) {
          return e && n.indexOf(Object.prototype.toString.call(e)) > -1;
        };
        f.prototype.append = function (e, t) {
          e = u(e), t = c(t);
          var n = this.map[e];
          this.map[e] = n ? n + "," + t : t;
        }, f.prototype.delete = function (e) {
          delete this.map[u(e)];
        }, f.prototype.get = function (e) {
          return e = u(e), this.has(e) ? this.map[e] : null;
        }, f.prototype.has = function (e) {
          return this.map.hasOwnProperty(u(e));
        }, f.prototype.set = function (e, t) {
          this.map[u(e)] = c(t);
        }, f.prototype.forEach = function (e, t) {
          for (var n in this.map) {
            this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
          }
        }, f.prototype.keys = function () {
          var e = [];
          return this.forEach(function (t, n) {
            e.push(n);
          }), a(e);
        }, f.prototype.values = function () {
          var e = [];
          return this.forEach(function (t) {
            e.push(t);
          }), a(e);
        }, f.prototype.entries = function () {
          var e = [];
          return this.forEach(function (t, n) {
            e.push([n, t]);
          }), a(e);
        }, t.iterable && (f.prototype[Symbol.iterator] = f.prototype.entries);
        var i = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        _.prototype.clone = function () {
          return new _(this, {
            body: this._bodyInit
          });
        }, y.call(_.prototype), y.call(b.prototype), b.prototype.clone = function () {
          return new b(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new f(this.headers),
            url: this.url
          });
        }, b.error = function () {
          var e = new b(null, {
            status: 0,
            statusText: ""
          });
          return e.type = "error", e;
        };
        var s = [301, 302, 303, 307, 308];
        b.redirect = function (e, t) {
          if (-1 === s.indexOf(t)) throw new RangeError("Invalid status code");
          return new b(null, {
            status: t,
            headers: {
              location: e
            }
          });
        }, e.Headers = f, e.Request = _, e.Response = b, e.fetch = function (e, n) {
          return new Promise(function (r, o) {
            var i = new _(e, n),
                s = new XMLHttpRequest();
            s.onload = function () {
              var e = {
                status: s.status,
                statusText: s.statusText,
                headers: function (e) {
                  var t = new f();
                  return e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e) {
                    var n = e.split(":"),
                        r = n.shift().trim();

                    if (r) {
                      var o = n.join(":").trim();
                      t.append(r, o);
                    }
                  }), t;
                }(s.getAllResponseHeaders() || "")
              };
              e.url = "responseURL" in s ? s.responseURL : e.headers.get("X-Request-URL");
              var t = "response" in s ? s.response : s.responseText;
              r(new b(t, e));
            }, s.onerror = function () {
              o(new TypeError("Network request failed"));
            }, s.ontimeout = function () {
              o(new TypeError("Network request failed"));
            }, s.open(i.method, i.url, !0), "include" === i.credentials ? s.withCredentials = !0 : "omit" === i.credentials && (s.withCredentials = !1), "responseType" in s && t.blob && (s.responseType = "blob"), i.headers.forEach(function (e, t) {
              s.setRequestHeader(t, e);
            }), s.send(void 0 === i._bodyInit ? null : i._bodyInit);
          });
        }, e.fetch.polyfill = !0;
      }

      function u(e) {
        if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
        return e.toLowerCase();
      }

      function c(e) {
        return "string" != typeof e && (e = String(e)), e;
      }

      function a(e) {
        var n = {
          next: function next() {
            var t = e.shift();
            return {
              done: void 0 === t,
              value: t
            };
          }
        };
        return t.iterable && (n[Symbol.iterator] = function () {
          return n;
        }), n;
      }

      function f(e) {
        this.map = {}, e instanceof f ? e.forEach(function (e, t) {
          this.append(t, e);
        }, this) : Array.isArray(e) ? e.forEach(function (e) {
          this.append(e[0], e[1]);
        }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
          this.append(t, e[t]);
        }, this);
      }

      function l(e) {
        if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
        e.bodyUsed = !0;
      }

      function h(e) {
        return new Promise(function (t, n) {
          e.onload = function () {
            t(e.result);
          }, e.onerror = function () {
            n(e.error);
          };
        });
      }

      function p(e) {
        var t = new FileReader(),
            n = h(t);
        return t.readAsArrayBuffer(e), n;
      }

      function d(e) {
        if (e.slice) return e.slice(0);
        var t = new Uint8Array(e.byteLength);
        return t.set(new Uint8Array(e)), t.buffer;
      }

      function y() {
        return this.bodyUsed = !1, this._initBody = function (e) {
          if (this._bodyInit = e, e) {
            if ("string" == typeof e) this._bodyText = e;else if (t.blob && Blob.prototype.isPrototypeOf(e)) this._bodyBlob = e;else if (t.formData && FormData.prototype.isPrototypeOf(e)) this._bodyFormData = e;else if (t.searchParams && URLSearchParams.prototype.isPrototypeOf(e)) this._bodyText = e.toString();else if (t.arrayBuffer && t.blob && r(e)) this._bodyArrayBuffer = d(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer]);else {
              if (!t.arrayBuffer || !ArrayBuffer.prototype.isPrototypeOf(e) && !o(e)) throw new Error("unsupported BodyInit type");
              this._bodyArrayBuffer = d(e);
            }
          } else this._bodyText = "";
          this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : t.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, t.blob && (this.blob = function () {
          var e = l(this);
          if (e) return e;
          if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData) throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function () {
          return this._bodyArrayBuffer ? l(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(p);
        }), this.text = function () {
          var e = l(this);
          if (e) return e;
          if (this._bodyBlob) return function (e) {
            var t = new FileReader(),
                n = h(t);
            return t.readAsText(e), n;
          }(this._bodyBlob);
          if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
            for (var t = new Uint8Array(e), n = new Array(t.length), r = 0; r < t.length; r++) {
              n[r] = String.fromCharCode(t[r]);
            }

            return n.join("");
          }(this._bodyArrayBuffer));
          if (this._bodyFormData) throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, t.formData && (this.formData = function () {
          return this.text().then(w);
        }), this.json = function () {
          return this.text().then(JSON.parse);
        }, this;
      }

      function _(e, t) {
        var n = (t = t || {}).body;

        if (e instanceof _) {
          if (e.bodyUsed) throw new TypeError("Already read");
          this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new f(e.headers)), this.method = e.method, this.mode = e.mode, n || null == e._bodyInit || (n = e._bodyInit, e.bodyUsed = !0);
        } else this.url = String(e);

        if (this.credentials = t.credentials || this.credentials || "omit", !t.headers && this.headers || (this.headers = new f(t.headers)), this.method = function (e) {
          var t = e.toUpperCase();
          return i.indexOf(t) > -1 ? t : e;
        }(t.method || this.method || "GET"), this.mode = t.mode || this.mode || null, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && n) throw new TypeError("Body not allowed for GET or HEAD requests");

        this._initBody(n);
      }

      function w(e) {
        var t = new FormData();
        return e.trim().split("&").forEach(function (e) {
          if (e) {
            var n = e.split("="),
                r = n.shift().replace(/\+/g, " "),
                o = n.join("=").replace(/\+/g, " ");
            t.append(decodeURIComponent(r), decodeURIComponent(o));
          }
        }), t;
      }

      function b(e, t) {
        t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new f(t.headers), this.url = t.url || "", this._initBody(e);
      }
    }("undefined" != typeof self ? self : this);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = n(0),
        i = r(n(13)),
        s = function () {
      function e() {
        this.exchangesList = {};
      }

      return e.prototype.getExchange = function (e, t) {
        return void 0 === t && (t = {
          networkId: o.NETWORKS.MAINNET,
          httpUrl: "",
          wsUrl: ""
        }), this.exchangesList[e] || (this.exchangesList[e] = this.createInstance(e, t)), this.exchangesList[e];
      }, e.prototype.createInstance = function (e, t) {
        var n = i.default[e];
        if (!n) throw new Error("Exchange not supported: " + e);
        if (!n.SUPPORTED_NETWORKS.includes(t.networkId)) throw new Error("Network Id not supported for selected network: " + t.networkId);
        return new n(t.networkId, t.httpUrl, t.wsUrl);
      }, e;
    }();

    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r;
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(14),
        i = n(3),
        s = n(20),
        u = n(0);
    t.default = ((r = {})[u.supportedExchanges.ETHFINEX] = o.Ethfinex, r[u.supportedExchanges.ETHFINEX_RAW] = i.EthfinexRaw, r[u.supportedExchanges.ZEROEXRELAYER] = s.ZeroExStandardRelayerRaw, r);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function s(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          e.done ? o(e.value) : new n(function (t) {
            t(e.value);
          }).then(s, u);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          s = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: u(0),
        throw: u(1),
        return: u(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function u(i) {
        return function (u) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; s;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return s.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    s.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = s.ops.pop(), s.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      s = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      s.label = i[1];
                      break;
                    }

                    if (6 === i[0] && s.label < o[1]) {
                      s.label = o[1], o = i;
                      break;
                    }

                    if (o && s.label < o[2]) {
                      s.label = o[2], s.ops.push(i);
                      break;
                    }

                    o[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }

                i = t.call(e, s);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, u]);
        };
      }
    },
        i = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(0),
        u = n(15),
        c = i(n(16)),
        a = i(n(3)),
        f = function () {
      function e(e, t, n) {
        var i = this;
        this.NETWORK_ID = e, this.HTTP_URL = t, this.WS_URL = n, this.http = {
          getOrders: function getOrders(e) {
            return r(i, void 0, void 0, function () {
              var t = this;
              return o(this, function (n) {
                return [2, this.raw.http.getOrders(e).then(function (e) {
                  return t.formatOrders(e);
                })];
              });
            });
          },
          getTickers: function getTickers(e) {
            return i.raw.http.getTickers(e).then(function (e) {
              return i.formatTickers(e);
            });
          },
          getCandles: function getCandles(e) {
            return i.raw.http.getCandles(e);
          }
        }, this.ws = {
          open: function open() {
            return i.raw.ws.open();
          },
          close: function close() {
            return i.raw.ws.close();
          },
          getConnection: function getConnection() {
            return i.raw.ws.getConnection();
          },
          getTickers: function getTickers(e, t) {
            return r(i, void 0, void 0, function () {
              return o(this, function (n) {
                return [2, this.raw.ws.getTickers(e, t)];
              });
            });
          },
          getCandles: function getCandles(e, t) {
            return r(i, void 0, void 0, function () {
              return o(this, function (n) {
                return [2, this.raw.ws.getCandles(e, t)];
              });
            });
          }
        }, this.raw = new a.default(e, t, n), this.options = this.raw.options;
      }

      return e.prototype.formatOrders = function (e) {
        if (this.checkForError(e)) throw new Error(e.pop());
        var t,
            n = [],
            r = [];
        return e.map(function (e) {
          var t = e.slice(e.length - 1).pop() > 0 ? u.OrderType.BUY : u.OrderType.SELL,
              o = new c.default(e.shift()).toFixed(s.PRICE_PRECISION),
              i = e.shift(),
              a = {
            orderPrice: o,
            orderAmount: new c.default(e.pop()).absoluteValue().toFixed(s.AMOUNT_PRECISION),
            ordersCount: i
          };
          return t === u.OrderType.BUY ? n.push(a) : r.push(a);
        }), t = n.length && r.length ? new c.default(r[0].orderPrice).minus(new c.default(n[0].orderPrice)).toFixed(6) : new c.default(0).toFixed(6), {
          aggregated: !0,
          asks: r.reverse(),
          bids: n,
          spread: t
        };
      }, e.prototype.formatTickers = function (e) {
        if (this.checkForError(e)) throw new Error(e.pop());
        if (!e.length) throw new Error("Tokens Pair not recognised by exchange");
        var t = e.map(function (e) {
          return {
            symbol: e[0].substring(1, 4),
            priceEth: e[7].toString(),
            priceUsd: ""
          };
        });
        return t.push({
          priceEth: "1",
          priceUsd: "",
          symbol: "WETH"
        }), t.push({
          priceEth: "1",
          priceUsd: "",
          symbol: "ETH"
        }), t;
      }, e.prototype.network = function (t) {
        return void 0 === t && (t = s.NETWORKS.MAINNET), new e(t);
      }, e.prototype.checkForError = function (e) {
        return "error" === e[0];
      }, e.SUPPORTED_NETWORKS = [s.NETWORKS.MAINNET, s.NETWORKS.ROPSTEN, s.NETWORKS.KOVAN], e;
    }();

    t.Ethfinex = f, t.default = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.BUY = 0] = "BUY", e[e.SELL = 1] = "SELL";
    }(t.OrderType || (t.OrderType = {}));
  }, function (e, t, n) {
    var r;
    !function (o) {
      "use strict";

      var i,
          s = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
          u = Math.ceil,
          c = Math.floor,
          a = "[BigNumber Error] ",
          f = a + "Number primitive has more than 15 significant digits: ",
          l = 1e14,
          h = 14,
          p = 9007199254740991,
          d = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
          y = 1e7,
          _ = 1e9;

      function w(e) {
        var t = 0 | e;
        return e > 0 || e === t ? t : t - 1;
      }

      function b(e) {
        for (var t, n, r = 1, o = e.length, i = e[0] + ""; r < o;) {
          for (t = e[r++] + "", n = h - t.length; n--; t = "0" + t) {
            ;
          }

          i += t;
        }

        for (o = i.length; 48 === i.charCodeAt(--o);) {
          ;
        }

        return i.slice(0, o + 1 || 1);
      }

      function m(e, t) {
        var n,
            r,
            o = e.c,
            i = t.c,
            s = e.s,
            u = t.s,
            c = e.e,
            a = t.e;
        if (!s || !u) return null;
        if (n = o && !o[0], r = i && !i[0], n || r) return n ? r ? 0 : -u : s;
        if (s != u) return s;
        if (n = s < 0, r = c == a, !o || !i) return r ? 0 : !o ^ n ? 1 : -1;
        if (!r) return c > a ^ n ? 1 : -1;

        for (u = (c = o.length) < (a = i.length) ? c : a, s = 0; s < u; s++) {
          if (o[s] != i[s]) return o[s] > i[s] ^ n ? 1 : -1;
        }

        return c == a ? 0 : c > a ^ n ? 1 : -1;
      }

      function v(e, t, n, r) {
        if (e < t || e > n || e !== (e < 0 ? u(e) : c(e))) throw Error(a + (r || "Argument") + ("number" == typeof e ? e < t || e > n ? " out of range: " : " not an integer: " : " not a primitive number: ") + e);
      }

      function g(e) {
        return "[object Array]" == Object.prototype.toString.call(e);
      }

      function E(e) {
        var t = e.c.length - 1;
        return w(e.e / h) == t && e.c[t] % 2 != 0;
      }

      function T(e, t) {
        return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (t < 0 ? "e" : "e+") + t;
      }

      function O(e, t, n) {
        var r, o;

        if (t < 0) {
          for (o = n + "."; ++t; o += n) {
            ;
          }

          e = o + e;
        } else if (++t > (r = e.length)) {
          for (o = n, t -= r; --t; o += n) {
            ;
          }

          e += o;
        } else t < r && (e = e.slice(0, t) + "." + e.slice(t));

        return e;
      }

      (i = function e(t) {
        var n,
            r,
            o,
            i = j.prototype = {
          constructor: j,
          toString: null,
          valueOf: null
        },
            S = new j(1),
            N = 20,
            R = 4,
            P = -7,
            A = 21,
            L = -1e7,
            x = 1e7,
            I = !1,
            C = 1,
            U = 0,
            k = {
          decimalSeparator: ".",
          groupSeparator: ",",
          groupSize: 3,
          secondaryGroupSize: 0,
          fractionGroupSeparator: " ",
          fractionGroupSize: 0
        },
            D = "0123456789abcdefghijklmnopqrstuvwxyz";

        function j(e, t) {
          var n,
              i,
              u,
              a,
              l,
              d,
              y,
              _,
              w = this;

          if (!(w instanceof j)) return new j(e, t);

          if (null == t) {
            if (e instanceof j) return w.s = e.s, w.e = e.e, void (w.c = (e = e.c) ? e.slice() : e);

            if ((d = "number" == typeof e) && 0 * e == 0) {
              if (w.s = 1 / e < 0 ? (e = -e, -1) : 1, e === ~~e) {
                for (a = 0, l = e; l >= 10; l /= 10, a++) {
                  ;
                }

                return w.e = a, void (w.c = [e]);
              }

              _ = e + "";
            } else {
              if (!s.test(_ = e + "")) return o(w, _, d);
              w.s = 45 == _.charCodeAt(0) ? (_ = _.slice(1), -1) : 1;
            }

            (a = _.indexOf(".")) > -1 && (_ = _.replace(".", "")), (l = _.search(/e/i)) > 0 ? (a < 0 && (a = l), a += +_.slice(l + 1), _ = _.substring(0, l)) : a < 0 && (a = _.length);
          } else {
            if (v(t, 2, D.length, "Base"), _ = e + "", 10 == t) return W(w = new j(e instanceof j ? e : _), N + w.e + 1, R);

            if (d = "number" == typeof e) {
              if (0 * e != 0) return o(w, _, d, t);
              if (w.s = 1 / e < 0 ? (_ = _.slice(1), -1) : 1, j.DEBUG && _.replace(/^0\.0*|\./, "").length > 15) throw Error(f + e);
              d = !1;
            } else w.s = 45 === _.charCodeAt(0) ? (_ = _.slice(1), -1) : 1;

            for (n = D.slice(0, t), a = l = 0, y = _.length; l < y; l++) {
              if (n.indexOf(i = _.charAt(l)) < 0) {
                if ("." == i) {
                  if (l > a) {
                    a = y;
                    continue;
                  }
                } else if (!u && (_ == _.toUpperCase() && (_ = _.toLowerCase()) || _ == _.toLowerCase() && (_ = _.toUpperCase()))) {
                  u = !0, l = -1, a = 0;
                  continue;
                }

                return o(w, e + "", d, t);
              }
            }

            (a = (_ = r(_, t, 10, w.s)).indexOf(".")) > -1 ? _ = _.replace(".", "") : a = _.length;
          }

          for (l = 0; 48 === _.charCodeAt(l); l++) {
            ;
          }

          for (y = _.length; 48 === _.charCodeAt(--y);) {
            ;
          }

          if (_ = _.slice(l, ++y)) {
            if (y -= l, d && j.DEBUG && y > 15 && (e > p || e !== c(e))) throw Error(f + w.s * e);
            if ((a = a - l - 1) > x) w.c = w.e = null;else if (a < L) w.c = [w.e = 0];else {
              if (w.e = a, w.c = [], l = (a + 1) % h, a < 0 && (l += h), l < y) {
                for (l && w.c.push(+_.slice(0, l)), y -= h; l < y;) {
                  w.c.push(+_.slice(l, l += h));
                }

                _ = _.slice(l), l = h - _.length;
              } else l -= y;

              for (; l--; _ += "0") {
                ;
              }

              w.c.push(+_);
            }
          } else w.c = [w.e = 0];
        }

        function F(e, t, n, r) {
          var o, i, s, u, c;
          if (null == n ? n = R : v(n, 0, 8), !e.c) return e.toString();
          if (o = e.c[0], s = e.e, null == t) c = b(e.c), c = 1 == r || 2 == r && s <= P ? T(c, s) : O(c, s, "0");else if (i = (e = W(new j(e), t, n)).e, u = (c = b(e.c)).length, 1 == r || 2 == r && (t <= i || i <= P)) {
            for (; u < t; c += "0", u++) {
              ;
            }

            c = T(c, i);
          } else if (t -= s, c = O(c, i, "0"), i + 1 > u) {
            if (--t > 0) for (c += "."; t--; c += "0") {
              ;
            }
          } else if ((t += i - u) > 0) for (i + 1 == u && (c += "."); t--; c += "0") {
            ;
          }
          return e.s < 0 && o ? "-" + c : c;
        }

        function M(e, t) {
          var n,
              r,
              o = 0;

          for (g(e[0]) && (e = e[0]), n = new j(e[0]); ++o < e.length;) {
            if (!(r = new j(e[o])).s) {
              n = r;
              break;
            }

            t.call(n, r) && (n = r);
          }

          return n;
        }

        function B(e, t, n) {
          for (var r = 1, o = t.length; !t[--o]; t.pop()) {
            ;
          }

          for (o = t[0]; o >= 10; o /= 10, r++) {
            ;
          }

          return (n = r + n * h - 1) > x ? e.c = e.e = null : n < L ? e.c = [e.e = 0] : (e.e = n, e.c = t), e;
        }

        function W(e, t, n, r) {
          var o,
              i,
              s,
              a,
              f,
              p,
              y,
              _ = e.c,
              w = d;

          if (_) {
            e: {
              for (o = 1, a = _[0]; a >= 10; a /= 10, o++) {
                ;
              }

              if ((i = t - o) < 0) i += h, s = t, y = (f = _[p = 0]) / w[o - s - 1] % 10 | 0;else if ((p = u((i + 1) / h)) >= _.length) {
                if (!r) break e;

                for (; _.length <= p; _.push(0)) {
                  ;
                }

                f = y = 0, o = 1, s = (i %= h) - h + 1;
              } else {
                for (f = a = _[p], o = 1; a >= 10; a /= 10, o++) {
                  ;
                }

                y = (s = (i %= h) - h + o) < 0 ? 0 : f / w[o - s - 1] % 10 | 0;
              }
              if (r = r || t < 0 || null != _[p + 1] || (s < 0 ? f : f % w[o - s - 1]), r = n < 4 ? (y || r) && (0 == n || n == (e.s < 0 ? 3 : 2)) : y > 5 || 5 == y && (4 == n || r || 6 == n && (i > 0 ? s > 0 ? f / w[o - s] : 0 : _[p - 1]) % 10 & 1 || n == (e.s < 0 ? 8 : 7)), t < 1 || !_[0]) return _.length = 0, r ? (t -= e.e + 1, _[0] = w[(h - t % h) % h], e.e = -t || 0) : _[0] = e.e = 0, e;
              if (0 == i ? (_.length = p, a = 1, p--) : (_.length = p + 1, a = w[h - i], _[p] = s > 0 ? c(f / w[o - s] % w[s]) * a : 0), r) for (;;) {
                if (0 == p) {
                  for (i = 1, s = _[0]; s >= 10; s /= 10, i++) {
                    ;
                  }

                  for (s = _[0] += a, a = 1; s >= 10; s /= 10, a++) {
                    ;
                  }

                  i != a && (e.e++, _[0] == l && (_[0] = 1));
                  break;
                }

                if (_[p] += a, _[p] != l) break;
                _[p--] = 0, a = 1;
              }

              for (i = _.length; 0 === _[--i]; _.pop()) {
                ;
              }
            }

            e.e > x ? e.c = e.e = null : e.e < L && (e.c = [e.e = 0]);
          }

          return e;
        }

        return j.clone = e, j.ROUND_UP = 0, j.ROUND_DOWN = 1, j.ROUND_CEIL = 2, j.ROUND_FLOOR = 3, j.ROUND_HALF_UP = 4, j.ROUND_HALF_DOWN = 5, j.ROUND_HALF_EVEN = 6, j.ROUND_HALF_CEIL = 7, j.ROUND_HALF_FLOOR = 8, j.EUCLID = 9, j.config = j.set = function (e) {
          var t, n;

          if (null != e) {
            if ("object" != typeof e) throw Error(a + "Object expected: " + e);
            if (e.hasOwnProperty(t = "DECIMAL_PLACES") && (v(n = e[t], 0, _, t), N = n), e.hasOwnProperty(t = "ROUNDING_MODE") && (v(n = e[t], 0, 8, t), R = n), e.hasOwnProperty(t = "EXPONENTIAL_AT") && (g(n = e[t]) ? (v(n[0], -_, 0, t), v(n[1], 0, _, t), P = n[0], A = n[1]) : (v(n, -_, _, t), P = -(A = n < 0 ? -n : n))), e.hasOwnProperty(t = "RANGE")) if (g(n = e[t])) v(n[0], -_, -1, t), v(n[1], 1, _, t), L = n[0], x = n[1];else {
              if (v(n, -_, _, t), !n) throw Error(a + t + " cannot be zero: " + n);
              L = -(x = n < 0 ? -n : n);
            }

            if (e.hasOwnProperty(t = "CRYPTO")) {
              if ((n = e[t]) !== !!n) throw Error(a + t + " not true or false: " + n);

              if (n) {
                if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw I = !n, Error(a + "crypto unavailable");
                I = n;
              } else I = n;
            }

            if (e.hasOwnProperty(t = "MODULO_MODE") && (v(n = e[t], 0, 9, t), C = n), e.hasOwnProperty(t = "POW_PRECISION") && (v(n = e[t], 0, _, t), U = n), e.hasOwnProperty(t = "FORMAT")) {
              if ("object" != typeof (n = e[t])) throw Error(a + t + " not an object: " + n);
              k = n;
            }

            if (e.hasOwnProperty(t = "ALPHABET")) {
              if ("string" != typeof (n = e[t]) || /^.$|\.|(.).*\1/.test(n)) throw Error(a + t + " invalid: " + n);
              D = n;
            }
          }

          return {
            DECIMAL_PLACES: N,
            ROUNDING_MODE: R,
            EXPONENTIAL_AT: [P, A],
            RANGE: [L, x],
            CRYPTO: I,
            MODULO_MODE: C,
            POW_PRECISION: U,
            FORMAT: k,
            ALPHABET: D
          };
        }, j.isBigNumber = function (e) {
          return e instanceof j || e && !0 === e._isBigNumber || !1;
        }, j.maximum = j.max = function () {
          return M(arguments, i.lt);
        }, j.minimum = j.min = function () {
          return M(arguments, i.gt);
        }, j.random = function () {
          var e = 9007199254740992 * Math.random() & 2097151 ? function () {
            return c(9007199254740992 * Math.random());
          } : function () {
            return 8388608 * (1073741824 * Math.random() | 0) + (8388608 * Math.random() | 0);
          };
          return function (t) {
            var n,
                r,
                o,
                i,
                s,
                f = 0,
                l = [],
                p = new j(S);
            if (null == t ? t = N : v(t, 0, _), i = u(t / h), I) if (crypto.getRandomValues) {
              for (n = crypto.getRandomValues(new Uint32Array(i *= 2)); f < i;) {
                (s = 131072 * n[f] + (n[f + 1] >>> 11)) >= 9e15 ? (r = crypto.getRandomValues(new Uint32Array(2)), n[f] = r[0], n[f + 1] = r[1]) : (l.push(s % 1e14), f += 2);
              }

              f = i / 2;
            } else {
              if (!crypto.randomBytes) throw I = !1, Error(a + "crypto unavailable");

              for (n = crypto.randomBytes(i *= 7); f < i;) {
                (s = 281474976710656 * (31 & n[f]) + 1099511627776 * n[f + 1] + 4294967296 * n[f + 2] + 16777216 * n[f + 3] + (n[f + 4] << 16) + (n[f + 5] << 8) + n[f + 6]) >= 9e15 ? crypto.randomBytes(7).copy(n, f) : (l.push(s % 1e14), f += 7);
              }

              f = i / 7;
            }
            if (!I) for (; f < i;) {
              (s = e()) < 9e15 && (l[f++] = s % 1e14);
            }

            for (i = l[--f], t %= h, i && t && (s = d[h - t], l[f] = c(i / s) * s); 0 === l[f]; l.pop(), f--) {
              ;
            }

            if (f < 0) l = [o = 0];else {
              for (o = -1; 0 === l[0]; l.splice(0, 1), o -= h) {
                ;
              }

              for (f = 1, s = l[0]; s >= 10; s /= 10, f++) {
                ;
              }

              f < h && (o -= h - f);
            }
            return p.e = o, p.c = l, p;
          };
        }(), r = function () {
          function e(e, t, n, r) {
            for (var o, i, s = [0], u = 0, c = e.length; u < c;) {
              for (i = s.length; i--; s[i] *= t) {
                ;
              }

              for (s[0] += r.indexOf(e.charAt(u++)), o = 0; o < s.length; o++) {
                s[o] > n - 1 && (null == s[o + 1] && (s[o + 1] = 0), s[o + 1] += s[o] / n | 0, s[o] %= n);
              }
            }

            return s.reverse();
          }

          return function (t, r, o, i, s) {
            var u,
                c,
                a,
                f,
                l,
                h,
                p,
                d,
                y = t.indexOf("."),
                _ = N,
                w = R;

            for (y >= 0 && (f = U, U = 0, t = t.replace(".", ""), h = (d = new j(r)).pow(t.length - y), U = f, d.c = e(O(b(h.c), h.e, "0"), 10, o, "0123456789"), d.e = d.c.length), a = f = (p = e(t, r, o, s ? (u = D, "0123456789") : (u = "0123456789", D))).length; 0 == p[--f]; p.pop()) {
              ;
            }

            if (!p[0]) return u.charAt(0);
            if (y < 0 ? --a : (h.c = p, h.e = a, h.s = i, p = (h = n(h, d, _, w, o)).c, l = h.r, a = h.e), y = p[c = a + _ + 1], f = o / 2, l = l || c < 0 || null != p[c + 1], l = w < 4 ? (null != y || l) && (0 == w || w == (h.s < 0 ? 3 : 2)) : y > f || y == f && (4 == w || l || 6 == w && 1 & p[c - 1] || w == (h.s < 0 ? 8 : 7)), c < 1 || !p[0]) t = l ? O(u.charAt(1), -_, u.charAt(0)) : u.charAt(0);else {
              if (p.length = c, l) for (--o; ++p[--c] > o;) {
                p[c] = 0, c || (++a, p = [1].concat(p));
              }

              for (f = p.length; !p[--f];) {
                ;
              }

              for (y = 0, t = ""; y <= f; t += u.charAt(p[y++])) {
                ;
              }

              t = O(t, a, u.charAt(0));
            }
            return t;
          };
        }(), n = function () {
          function e(e, t, n) {
            var r,
                o,
                i,
                s,
                u = 0,
                c = e.length,
                a = t % y,
                f = t / y | 0;

            for (e = e.slice(); c--;) {
              u = ((o = a * (i = e[c] % y) + (r = f * i + (s = e[c] / y | 0) * a) % y * y + u) / n | 0) + (r / y | 0) + f * s, e[c] = o % n;
            }

            return u && (e = [u].concat(e)), e;
          }

          function t(e, t, n, r) {
            var o, i;
            if (n != r) i = n > r ? 1 : -1;else for (o = i = 0; o < n; o++) {
              if (e[o] != t[o]) {
                i = e[o] > t[o] ? 1 : -1;
                break;
              }
            }
            return i;
          }

          function n(e, t, n, r) {
            for (var o = 0; n--;) {
              e[n] -= o, o = e[n] < t[n] ? 1 : 0, e[n] = o * r + e[n] - t[n];
            }

            for (; !e[0] && e.length > 1; e.splice(0, 1)) {
              ;
            }
          }

          return function (r, o, i, s, u) {
            var a,
                f,
                p,
                d,
                y,
                _,
                b,
                m,
                v,
                g,
                E,
                T,
                O,
                S,
                N,
                R,
                P,
                A = r.s == o.s ? 1 : -1,
                L = r.c,
                x = o.c;

            if (!(L && L[0] && x && x[0])) return new j(r.s && o.s && (L ? !x || L[0] != x[0] : x) ? L && 0 == L[0] || !x ? 0 * A : A / 0 : NaN);

            for (v = (m = new j(A)).c = [], A = i + (f = r.e - o.e) + 1, u || (u = l, f = w(r.e / h) - w(o.e / h), A = A / h | 0), p = 0; x[p] == (L[p] || 0); p++) {
              ;
            }

            if (x[p] > (L[p] || 0) && f--, A < 0) v.push(1), d = !0;else {
              for (S = L.length, R = x.length, p = 0, A += 2, (y = c(u / (x[0] + 1))) > 1 && (x = e(x, y, u), L = e(L, y, u), R = x.length, S = L.length), O = R, E = (g = L.slice(0, R)).length; E < R; g[E++] = 0) {
                ;
              }

              P = x.slice(), P = [0].concat(P), N = x[0], x[1] >= u / 2 && N++;

              do {
                if (y = 0, (a = t(x, g, R, E)) < 0) {
                  if (T = g[0], R != E && (T = T * u + (g[1] || 0)), (y = c(T / N)) > 1) for (y >= u && (y = u - 1), b = (_ = e(x, y, u)).length, E = g.length; 1 == t(_, g, b, E);) {
                    y--, n(_, R < b ? P : x, b, u), b = _.length, a = 1;
                  } else 0 == y && (a = y = 1), b = (_ = x.slice()).length;
                  if (b < E && (_ = [0].concat(_)), n(g, _, E, u), E = g.length, -1 == a) for (; t(x, g, R, E) < 1;) {
                    y++, n(g, R < E ? P : x, E, u), E = g.length;
                  }
                } else 0 === a && (y++, g = [0]);

                v[p++] = y, g[0] ? g[E++] = L[O] || 0 : (g = [L[O]], E = 1);
              } while ((O++ < S || null != g[0]) && A--);

              d = null != g[0], v[0] || v.splice(0, 1);
            }

            if (u == l) {
              for (p = 1, A = v[0]; A >= 10; A /= 10, p++) {
                ;
              }

              W(m, i + (m.e = p + f * h - 1) + 1, s, d);
            } else m.e = f, m.r = +d;

            return m;
          };
        }(), o = function () {
          var e = /^(-?)0([xbo])(?=\w[\w.]*$)/i,
              t = /^([^.]+)\.$/,
              n = /^\.([^.]+)$/,
              r = /^-?(Infinity|NaN)$/,
              o = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
          return function (i, s, u, c) {
            var f,
                l = u ? s : s.replace(o, "");
            if (r.test(l)) i.s = isNaN(l) ? null : l < 0 ? -1 : 1, i.c = i.e = null;else {
              if (!u && (l = l.replace(e, function (e, t, n) {
                return f = "x" == (n = n.toLowerCase()) ? 16 : "b" == n ? 2 : 8, c && c != f ? e : t;
              }), c && (f = c, l = l.replace(t, "$1").replace(n, "0.$1")), s != l)) return new j(l, f);
              if (j.DEBUG) throw Error(a + "Not a" + (c ? " base " + c : "") + " number: " + s);
              i.c = i.e = i.s = null;
            }
          };
        }(), i.absoluteValue = i.abs = function () {
          var e = new j(this);
          return e.s < 0 && (e.s = 1), e;
        }, i.comparedTo = function (e, t) {
          return m(this, new j(e, t));
        }, i.decimalPlaces = i.dp = function (e, t) {
          var n,
              r,
              o,
              i = this;
          if (null != e) return v(e, 0, _), null == t ? t = R : v(t, 0, 8), W(new j(i), e + i.e + 1, t);
          if (!(n = i.c)) return null;
          if (r = ((o = n.length - 1) - w(this.e / h)) * h, o = n[o]) for (; o % 10 == 0; o /= 10, r--) {
            ;
          }
          return r < 0 && (r = 0), r;
        }, i.dividedBy = i.div = function (e, t) {
          return n(this, new j(e, t), N, R);
        }, i.dividedToIntegerBy = i.idiv = function (e, t) {
          return n(this, new j(e, t), 0, 1);
        }, i.exponentiatedBy = i.pow = function (e, t) {
          var n,
              r,
              o,
              i,
              s,
              f,
              l,
              p = this;
          if ((e = new j(e)).c && !e.isInteger()) throw Error(a + "Exponent not an integer: " + e);
          if (null != t && (t = new j(t)), i = e.e > 14, !p.c || !p.c[0] || 1 == p.c[0] && !p.e && 1 == p.c.length || !e.c || !e.c[0]) return l = new j(Math.pow(+p.valueOf(), i ? 2 - E(e) : +e)), t ? l.mod(t) : l;

          if (s = e.s < 0, t) {
            if (t.c ? !t.c[0] : !t.s) return new j(NaN);
            (r = !s && p.isInteger() && t.isInteger()) && (p = p.mod(t));
          } else {
            if (e.e > 9 && (p.e > 0 || p.e < -1 || (0 == p.e ? p.c[0] > 1 || i && p.c[1] >= 24e7 : p.c[0] < 8e13 || i && p.c[0] <= 9999975e7))) return o = p.s < 0 && E(e) ? -0 : 0, p.e > -1 && (o = 1 / o), new j(s ? 1 / o : o);
            U && (o = u(U / h + 2));
          }

          for (i ? (n = new j(.5), f = E(e)) : f = e % 2, s && (e.s = 1), l = new j(S);;) {
            if (f) {
              if (!(l = l.times(p)).c) break;
              o ? l.c.length > o && (l.c.length = o) : r && (l = l.mod(t));
            }

            if (i) {
              if (W(e = e.times(n), e.e + 1, 1), !e.c[0]) break;
              i = e.e > 14, f = E(e);
            } else {
              if (!(e = c(e / 2))) break;
              f = e % 2;
            }

            p = p.times(p), o ? p.c && p.c.length > o && (p.c.length = o) : r && (p = p.mod(t));
          }

          return r ? l : (s && (l = S.div(l)), t ? l.mod(t) : o ? W(l, U, R, void 0) : l);
        }, i.integerValue = function (e) {
          var t = new j(this);
          return null == e ? e = R : v(e, 0, 8), W(t, t.e + 1, e);
        }, i.isEqualTo = i.eq = function (e, t) {
          return 0 === m(this, new j(e, t));
        }, i.isFinite = function () {
          return !!this.c;
        }, i.isGreaterThan = i.gt = function (e, t) {
          return m(this, new j(e, t)) > 0;
        }, i.isGreaterThanOrEqualTo = i.gte = function (e, t) {
          return 1 === (t = m(this, new j(e, t))) || 0 === t;
        }, i.isInteger = function () {
          return !!this.c && w(this.e / h) > this.c.length - 2;
        }, i.isLessThan = i.lt = function (e, t) {
          return m(this, new j(e, t)) < 0;
        }, i.isLessThanOrEqualTo = i.lte = function (e, t) {
          return -1 === (t = m(this, new j(e, t))) || 0 === t;
        }, i.isNaN = function () {
          return !this.s;
        }, i.isNegative = function () {
          return this.s < 0;
        }, i.isPositive = function () {
          return this.s > 0;
        }, i.isZero = function () {
          return !!this.c && 0 == this.c[0];
        }, i.minus = function (e, t) {
          var n,
              r,
              o,
              i,
              s = this,
              u = s.s;
          if (t = (e = new j(e, t)).s, !u || !t) return new j(NaN);
          if (u != t) return e.s = -t, s.plus(e);
          var c = s.e / h,
              a = e.e / h,
              f = s.c,
              p = e.c;

          if (!c || !a) {
            if (!f || !p) return f ? (e.s = -t, e) : new j(p ? s : NaN);
            if (!f[0] || !p[0]) return p[0] ? (e.s = -t, e) : new j(f[0] ? s : 3 == R ? -0 : 0);
          }

          if (c = w(c), a = w(a), f = f.slice(), u = c - a) {
            for ((i = u < 0) ? (u = -u, o = f) : (a = c, o = p), o.reverse(), t = u; t--; o.push(0)) {
              ;
            }

            o.reverse();
          } else for (r = (i = (u = f.length) < (t = p.length)) ? u : t, u = t = 0; t < r; t++) {
            if (f[t] != p[t]) {
              i = f[t] < p[t];
              break;
            }
          }

          if (i && (o = f, f = p, p = o, e.s = -e.s), (t = (r = p.length) - (n = f.length)) > 0) for (; t--; f[n++] = 0) {
            ;
          }

          for (t = l - 1; r > u;) {
            if (f[--r] < p[r]) {
              for (n = r; n && !f[--n]; f[n] = t) {
                ;
              }

              --f[n], f[r] += l;
            }

            f[r] -= p[r];
          }

          for (; 0 == f[0]; f.splice(0, 1), --a) {
            ;
          }

          return f[0] ? B(e, f, a) : (e.s = 3 == R ? -1 : 1, e.c = [e.e = 0], e);
        }, i.modulo = i.mod = function (e, t) {
          var r,
              o,
              i = this;
          return e = new j(e, t), !i.c || !e.s || e.c && !e.c[0] ? new j(NaN) : !e.c || i.c && !i.c[0] ? new j(i) : (9 == C ? (o = e.s, e.s = 1, r = n(i, e, 0, 3), e.s = o, r.s *= o) : r = n(i, e, 0, C), (e = i.minus(r.times(e))).c[0] || 1 != C || (e.s = i.s), e);
        }, i.multipliedBy = i.times = function (e, t) {
          var n,
              r,
              o,
              i,
              s,
              u,
              c,
              a,
              f,
              p,
              d,
              _,
              b,
              m,
              v,
              g = this,
              E = g.c,
              T = (e = new j(e, t)).c;

          if (!(E && T && E[0] && T[0])) return !g.s || !e.s || E && !E[0] && !T || T && !T[0] && !E ? e.c = e.e = e.s = null : (e.s *= g.s, E && T ? (e.c = [0], e.e = 0) : e.c = e.e = null), e;

          for (r = w(g.e / h) + w(e.e / h), e.s *= g.s, (c = E.length) < (p = T.length) && (b = E, E = T, T = b, o = c, c = p, p = o), o = c + p, b = []; o--; b.push(0)) {
            ;
          }

          for (m = l, v = y, o = p; --o >= 0;) {
            for (n = 0, d = T[o] % v, _ = T[o] / v | 0, i = o + (s = c); i > o;) {
              n = ((a = d * (a = E[--s] % v) + (u = _ * a + (f = E[s] / v | 0) * d) % v * v + b[i] + n) / m | 0) + (u / v | 0) + _ * f, b[i--] = a % m;
            }

            b[i] = n;
          }

          return n ? ++r : b.splice(0, 1), B(e, b, r);
        }, i.negated = function () {
          var e = new j(this);
          return e.s = -e.s || null, e;
        }, i.plus = function (e, t) {
          var n,
              r = this,
              o = r.s;
          if (t = (e = new j(e, t)).s, !o || !t) return new j(NaN);
          if (o != t) return e.s = -t, r.minus(e);
          var i = r.e / h,
              s = e.e / h,
              u = r.c,
              c = e.c;

          if (!i || !s) {
            if (!u || !c) return new j(o / 0);
            if (!u[0] || !c[0]) return c[0] ? e : new j(u[0] ? r : 0 * o);
          }

          if (i = w(i), s = w(s), u = u.slice(), o = i - s) {
            for (o > 0 ? (s = i, n = c) : (o = -o, n = u), n.reverse(); o--; n.push(0)) {
              ;
            }

            n.reverse();
          }

          for ((o = u.length) - (t = c.length) < 0 && (n = c, c = u, u = n, t = o), o = 0; t;) {
            o = (u[--t] = u[t] + c[t] + o) / l | 0, u[t] = l === u[t] ? 0 : u[t] % l;
          }

          return o && (u = [o].concat(u), ++s), B(e, u, s);
        }, i.precision = i.sd = function (e, t) {
          var n,
              r,
              o,
              i = this;
          if (null != e && e !== !!e) return v(e, 1, _), null == t ? t = R : v(t, 0, 8), W(new j(i), e, t);
          if (!(n = i.c)) return null;

          if (r = (o = n.length - 1) * h + 1, o = n[o]) {
            for (; o % 10 == 0; o /= 10, r--) {
              ;
            }

            for (o = n[0]; o >= 10; o /= 10, r++) {
              ;
            }
          }

          return e && i.e + 1 > r && (r = i.e + 1), r;
        }, i.shiftedBy = function (e) {
          return v(e, -p, p), this.times("1e" + e);
        }, i.squareRoot = i.sqrt = function () {
          var e,
              t,
              r,
              o,
              i,
              s = this,
              u = s.c,
              c = s.s,
              a = s.e,
              f = N + 4,
              l = new j("0.5");
          if (1 !== c || !u || !u[0]) return new j(!c || c < 0 && (!u || u[0]) ? NaN : u ? s : 1 / 0);
          if (0 == (c = Math.sqrt(+s)) || c == 1 / 0 ? (((t = b(u)).length + a) % 2 == 0 && (t += "0"), c = Math.sqrt(t), a = w((a + 1) / 2) - (a < 0 || a % 2), r = new j(t = c == 1 / 0 ? "1e" + a : (t = c.toExponential()).slice(0, t.indexOf("e") + 1) + a)) : r = new j(c + ""), r.c[0]) for ((c = (a = r.e) + f) < 3 && (c = 0);;) {
            if (i = r, r = l.times(i.plus(n(s, i, f, 1))), b(i.c).slice(0, c) === (t = b(r.c)).slice(0, c)) {
              if (r.e < a && --c, "9999" != (t = t.slice(c - 3, c + 1)) && (o || "4999" != t)) {
                +t && (+t.slice(1) || "5" != t.charAt(0)) || (W(r, r.e + N + 2, 1), e = !r.times(r).eq(s));
                break;
              }

              if (!o && (W(i, i.e + N + 2, 0), i.times(i).eq(s))) {
                r = i;
                break;
              }

              f += 4, c += 4, o = 1;
            }
          }
          return W(r, r.e + N + 1, R, e);
        }, i.toExponential = function (e, t) {
          return null != e && (v(e, 0, _), e++), F(this, e, t, 1);
        }, i.toFixed = function (e, t) {
          return null != e && (v(e, 0, _), e = e + this.e + 1), F(this, e, t);
        }, i.toFormat = function (e, t) {
          var n = this.toFixed(e, t);

          if (this.c) {
            var r,
                o = n.split("."),
                i = +k.groupSize,
                s = +k.secondaryGroupSize,
                u = k.groupSeparator,
                c = o[0],
                a = o[1],
                f = this.s < 0,
                l = f ? c.slice(1) : c,
                h = l.length;

            if (s && (r = i, i = s, s = r, h -= r), i > 0 && h > 0) {
              for (r = h % i || i, c = l.substr(0, r); r < h; r += i) {
                c += u + l.substr(r, i);
              }

              s > 0 && (c += u + l.slice(r)), f && (c = "-" + c);
            }

            n = a ? c + k.decimalSeparator + ((s = +k.fractionGroupSize) ? a.replace(new RegExp("\\d{" + s + "}\\B", "g"), "$&" + k.fractionGroupSeparator) : a) : c;
          }

          return n;
        }, i.toFraction = function (e) {
          var t,
              r,
              o,
              i,
              s,
              u,
              c,
              f,
              l,
              p,
              y,
              _,
              w = this,
              m = w.c;

          if (null != e && (!(f = new j(e)).isInteger() && (f.c || 1 !== f.s) || f.lt(S))) throw Error(a + "Argument " + (f.isInteger() ? "out of range: " : "not an integer: ") + e);
          if (!m) return w.toString();

          for (r = new j(S), p = o = new j(S), i = l = new j(S), _ = b(m), u = r.e = _.length - w.e - 1, r.c[0] = d[(c = u % h) < 0 ? h + c : c], e = !e || f.comparedTo(r) > 0 ? u > 0 ? r : p : f, c = x, x = 1 / 0, f = new j(_), l.c[0] = 0; y = n(f, r, 0, 1), 1 != (s = o.plus(y.times(i))).comparedTo(e);) {
            o = i, i = s, p = l.plus(y.times(s = p)), l = s, r = f.minus(y.times(s = r)), f = s;
          }

          return s = n(e.minus(o), i, 0, 1), l = l.plus(s.times(p)), o = o.plus(s.times(i)), l.s = p.s = w.s, t = n(p, i, u *= 2, R).minus(w).abs().comparedTo(n(l, o, u, R).minus(w).abs()) < 1 ? [p.toString(), i.toString()] : [l.toString(), o.toString()], x = c, t;
        }, i.toNumber = function () {
          return +this;
        }, i.toPrecision = function (e, t) {
          return null != e && v(e, 1, _), F(this, e, t, 2);
        }, i.toString = function (e) {
          var t,
              n = this,
              o = n.s,
              i = n.e;
          return null === i ? o ? (t = "Infinity", o < 0 && (t = "-" + t)) : t = "NaN" : (t = b(n.c), null == e ? t = i <= P || i >= A ? T(t, i) : O(t, i, "0") : (v(e, 2, D.length, "Base"), t = r(O(t, i, "0"), 10, e, o, !0)), o < 0 && n.c[0] && (t = "-" + t)), t;
        }, i.valueOf = i.toJSON = function () {
          var e,
              t = this,
              n = t.e;
          return null === n ? t.toString() : (e = b(t.c), e = n <= P || n >= A ? T(e, n) : O(e, n, "0"), t.s < 0 ? "-" + e : e);
        }, i._isBigNumber = !0, null != t && j.set(t), j;
      }()).default = i.BigNumber = i, void 0 === (r = function () {
        return i;
      }.call(t, n, t, e)) || (e.exports = r);
    }();
  }, function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0
    
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.
    
    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var _r = function r(e, t) {
      return (_r = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    };

    function o(e, t) {
      function n() {
        this.constructor = e;
      }

      _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }

    var i = function () {
      return function (e, t) {
        this.target = t, this.type = e;
      };
    }(),
        s = function (e) {
      function t(t, n) {
        var r = e.call(this, "error", n) || this;
        return r.message = t.message, r.error = t, r;
      }

      return o(t, e), t;
    }(i),
        u = function (e) {
      function t(t, n, r) {
        void 0 === t && (t = 1e3), void 0 === n && (n = "");
        var o = e.call(this, "close", r) || this;
        return o.wasClean = !0, o.code = t, o.reason = n, o;
      }

      return o(t, e), t;
    }(i),
        c = function c() {
      if ("undefined" != typeof WebSocket) return WebSocket;
    },
        a = {
      maxReconnectionDelay: 1e4,
      minReconnectionDelay: 1e3 + 4e3 * Math.random(),
      minUptime: 5e3,
      reconnectionDelayGrowFactor: 1.3,
      connectionTimeout: 4e3,
      maxRetries: 1 / 0,
      debug: !1
    },
        f = function () {
      function e(e, t, n) {
        void 0 === n && (n = {});
        var r = this;
        this._listeners = {
          error: [],
          message: [],
          open: [],
          close: []
        }, this._retryCount = -1, this._shouldReconnect = !0, this._connectLock = !1, this._binaryType = "blob", this._closeCalled = !1, this._messageQueue = [], this.onclose = void 0, this.onerror = void 0, this.onmessage = void 0, this.onopen = void 0, this._handleOpen = function (e) {
          r._debug("open event");

          var t = r._options.minUptime,
              n = void 0 === t ? a.minUptime : t;
          clearTimeout(r._connectTimeout), r._uptimeTimeout = setTimeout(function () {
            return r._acceptOpen();
          }, n), r._ws.binaryType = r._binaryType, r._messageQueue.forEach(function (e) {
            return r._ws.send(e);
          }), r._messageQueue = [], r.onopen && r.onopen(e), r._listeners.open.forEach(function (t) {
            return r._callEventListener(e, t);
          });
        }, this._handleMessage = function (e) {
          r._debug("message event"), r.onmessage && r.onmessage(e), r._listeners.message.forEach(function (t) {
            return r._callEventListener(e, t);
          });
        }, this._handleError = function (e) {
          r._debug("error event", e.message), r._disconnect(void 0, "TIMEOUT" === e.message ? "timeout" : void 0), r.onerror && r.onerror(e), r._debug("exec error listeners"), r._listeners.error.forEach(function (t) {
            return r._callEventListener(e, t);
          }), r._connect();
        }, this._handleClose = function (e) {
          r._debug("close event"), r._clearTimeouts(), r._shouldReconnect && r._connect(), r.onclose && r.onclose(e), r._listeners.close.forEach(function (t) {
            return r._callEventListener(e, t);
          });
        }, this._url = e, this._protocols = t, this._options = n, this._connect();
      }

      return Object.defineProperty(e, "CONNECTING", {
        get: function get() {
          return 0;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e, "OPEN", {
        get: function get() {
          return 1;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e, "CLOSING", {
        get: function get() {
          return 2;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e, "CLOSED", {
        get: function get() {
          return 3;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "CONNECTING", {
        get: function get() {
          return e.CONNECTING;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "OPEN", {
        get: function get() {
          return e.OPEN;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "CLOSING", {
        get: function get() {
          return e.CLOSING;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "CLOSED", {
        get: function get() {
          return e.CLOSED;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "binaryType", {
        get: function get() {
          return this._ws ? this._ws.binaryType : this._binaryType;
        },
        set: function set(e) {
          this._binaryType = e, this._ws && (this._ws.binaryType = e);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "retryCount", {
        get: function get() {
          return Math.max(this._retryCount, 0);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "bufferedAmount", {
        get: function get() {
          return this._messageQueue.reduce(function (e, t) {
            return "string" == typeof t ? e += t.length : t instanceof Blob ? e += t.size : e += t.byteLength, e;
          }, 0) + (this._ws ? this._ws.bufferedAmount : 0);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "extensions", {
        get: function get() {
          return this._ws ? this._ws.extensions : "";
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "protocol", {
        get: function get() {
          return this._ws ? this._ws.protocol : "";
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "readyState", {
        get: function get() {
          return this._ws ? this._ws.readyState : e.CONNECTING;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "url", {
        get: function get() {
          return this._ws ? this._ws.url : "";
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.close = function (e, t) {
        void 0 === e && (e = 1e3), this._closeCalled = !0, this._shouldReconnect = !1, this._clearTimeouts(), this._ws ? this._ws.readyState !== this.CLOSED ? this._ws.close(e, t) : this._debug("close: already closed") : this._debug("close enqueued: no ws instance");
      }, e.prototype.reconnect = function (e, t) {
        this._shouldReconnect = !0, this._closeCalled = !1, this._retryCount = -1, this._ws && this._ws.readyState !== this.CLOSED ? (this._disconnect(e, t), this._connect()) : this._connect();
      }, e.prototype.send = function (e) {
        this._ws && this._ws.readyState === this.OPEN ? (this._debug("send", e), this._ws.send(e)) : (this._debug("enqueue", e), this._messageQueue.push(e));
      }, e.prototype.addEventListener = function (e, t) {
        this._listeners[e] && this._listeners[e].push(t);
      }, e.prototype.removeEventListener = function (e, t) {
        this._listeners[e] && (this._listeners[e] = this._listeners[e].filter(function (e) {
          return e !== t;
        }));
      }, e.prototype._debug = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        this._options.debug && console.log.apply(console, ["RWS>"].concat(e));
      }, e.prototype._getNextDelay = function () {
        var e = this._options,
            t = e.reconnectionDelayGrowFactor,
            n = void 0 === t ? a.reconnectionDelayGrowFactor : t,
            r = e.minReconnectionDelay,
            o = void 0 === r ? a.minReconnectionDelay : r,
            i = e.maxReconnectionDelay,
            s = void 0 === i ? a.maxReconnectionDelay : i,
            u = o;
        return this._retryCount > 0 && (u = o * Math.pow(n, this._retryCount - 1)) > s && (u = s), this._debug("next delay", u), u;
      }, e.prototype._wait = function () {
        var e = this;
        return new Promise(function (t) {
          setTimeout(t, e._getNextDelay());
        });
      }, e.prototype._getNextUrl = function (e) {
        if ("string" == typeof e) return Promise.resolve(e);

        if ("function" == typeof e) {
          var t = e();
          if ("string" == typeof t) return Promise.resolve(t);
          if (t.then) return t;
        }

        throw Error("Invalid URL");
      }, e.prototype._connect = function () {
        var e = this;

        if (!this._connectLock && this._shouldReconnect) {
          this._connectLock = !0;
          var t = this._options,
              n = t.maxRetries,
              r = void 0 === n ? a.maxRetries : n,
              o = t.connectionTimeout,
              i = void 0 === o ? a.connectionTimeout : o,
              s = t.WebSocket,
              u = void 0 === s ? c() : s;
          if (this._retryCount >= r) this._debug("max retries reached", this._retryCount, ">=", r);else {
            if (this._retryCount++, this._debug("connect", this._retryCount), this._removeListeners(), !function (e) {
              return "function" == typeof e && 2 === e.CLOSING;
            }(u)) throw Error("No valid WebSocket class provided");

            this._wait().then(function () {
              return e._getNextUrl(e._url);
            }).then(function (t) {
              e._closeCalled ? e._connectLock = !1 : (e._debug("connect", {
                url: t,
                protocols: e._protocols
              }), e._ws = e._protocols ? new u(t, e._protocols) : new u(t), e._ws.binaryType = e._binaryType, e._connectLock = !1, e._addListeners(), e._connectTimeout = setTimeout(function () {
                return e._handleTimeout();
              }, i));
            });
          }
        }
      }, e.prototype._handleTimeout = function () {
        this._debug("timeout event"), this._handleError(new s(Error("TIMEOUT"), this));
      }, e.prototype._disconnect = function (e, t) {
        if (void 0 === e && (e = 1e3), this._clearTimeouts(), this._ws) {
          this._removeListeners();

          try {
            this._ws.close(e, t), this._handleClose(new u(e, t, this));
          } catch (e) {}
        }
      }, e.prototype._acceptOpen = function () {
        this._debug("accept open"), this._retryCount = 0;
      }, e.prototype._callEventListener = function (e, t) {
        "handleEvent" in t ? t.handleEvent(e) : t(e);
      }, e.prototype._removeListeners = function () {
        this._ws && (this._debug("removeListeners"), this._ws.removeEventListener("open", this._handleOpen), this._ws.removeEventListener("close", this._handleClose), this._ws.removeEventListener("message", this._handleMessage), this._ws.removeEventListener("error", this._handleError));
      }, e.prototype._addListeners = function () {
        this._ws && (this._debug("addListeners"), this._ws.addEventListener("open", this._handleOpen), this._ws.addEventListener("close", this._handleClose), this._ws.addEventListener("message", this._handleMessage), this._ws.addEventListener("error", this._handleError));
      }, e.prototype._clearTimeouts = function () {
        clearTimeout(this._connectTimeout), clearTimeout(this._uptimeTimeout);
      }, e;
    }();

    t.default = f;
  }, function (e, t, n) {
    "use strict";

    e.exports = function () {
      throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__awaiter || function (e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function s(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          e.done ? o(e.value) : new n(function (t) {
            t(e.value);
          }).then(s, u);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var n,
          r,
          o,
          i,
          s = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: u(0),
        throw: u(1),
        return: u(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function u(i) {
        return function (u) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; s;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return s.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    s.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = s.ops.pop(), s.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = s.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      s = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      s.label = i[1];
                      break;
                    }

                    if (6 === i[0] && s.label < o[1]) {
                      s.label = o[1], o = i;
                      break;
                    }

                    if (o && s.label < o[2]) {
                      s.label = o[2], s.ops.push(i);
                      break;
                    }

                    o[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }

                i = t.call(e, s);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, u]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(0),
        s = n(4),
        u = function () {
      function e(e, t, n) {
        var i = this;
        if (this.networkId = e, this.STANDARD_HTTP_URL = t, this.STANDARD_WS_URL = n, this.http = {
          getTokenPairs: function getTokenPairs(e) {
            return r(i, void 0, void 0, function () {
              var t, n;
              return o(this, function (r) {
                return t = this.STANDARD_HTTP_URL + "/v0/token_pairs", n = s.getQueryParameters(e), [2, s.fetchJSON(t, n)];
              });
            });
          },
          getOrders: function getOrders(e) {
            return r(i, void 0, void 0, function () {
              var t, n;
              return o(this, function (r) {
                return t = this.STANDARD_HTTP_URL + "/v0/orders", n = s.getQueryParameters(e), [2, s.fetchJSON(t, n)];
              });
            });
          },
          getOrder: function getOrder(e) {
            return r(i, void 0, void 0, function () {
              var t;
              return o(this, function (n) {
                return t = this.STANDARD_HTTP_URL + "/v0/order/" + e.orderHash, [2, s.fetchJSON(t)];
              });
            });
          },
          getOrderbook: function getOrderbook(e) {
            return r(i, void 0, void 0, function () {
              var t, n;
              return o(this, function (r) {
                return t = this.STANDARD_HTTP_URL + "/v0/orderbook", n = s.getQueryParameters(e), [2, s.fetchJSON(t, n)];
              });
            });
          },
          getFees: function getFees(e) {
            return r(i, void 0, void 0, function () {
              var t;
              return o(this, function (n) {
                return t = this.STANDARD_HTTP_URL + "/v0/fees", [2, s.postJSON(t, e)];
              });
            });
          },
          createOrder: function createOrder(e) {
            return r(i, void 0, void 0, function () {
              var t;
              return o(this, function (n) {
                return t = this.STANDARD_HTTP_URL + "/v0/order", [2, s.postJSON(t, e)];
              });
            });
          }
        }, this.ws = {}, !t) throw new Error("API url must be specified for 0x standard relayers.");
      }

      return e.SUPPORTED_NETWORKS = [i.NETWORKS.MAINNET, i.NETWORKS.KOVAN, i.NETWORKS.ROPSTEN], e;
    }();

    t.ZeroExStandardRelayerRaw = u, t.default = u;
  }]);
});